<app-loading [loader]="isLoading"></app-loading>
<div class="row" *ngIf="!isLoading">
  <div class="col-lg-12">
    <div class="ibox">
      <div class="ibox-title">
        <h5>Entregável</h5>
      </div>
      <div class="ibox-content">
        <label>Projeto</label>
        <p>{{ entrega?.projeto?.full_title }}</p>
        <label>Entregável</label>
        <p>{{ entrega?.projeto?.entregavel }}</p>
        <div class="row">
          <div class="col-sm-3">
            <label>Previsão de início</label>
            <p>{{ entrega?.projeto?.dt_start }}</p>
          </div>
          <div class="col-sm-3">
            <label>Prazo planejado</label>
            <p>{{ entrega?.projeto?.dt_conclusion }}</p>
          </div>
          <div class="col-sm-6">
            <label>Responsável</label>
            <p>{{ entrega?.projeto?.responsavel }}</p>
          </div>
        </div>
        
      </div>
    </div>

    <div class="ibox" *ngIf="!itensRelatorio">
      <div class="ibox-content">
        Nenhum item selecionado.
      </div>
    </div>

    <div class="ibox" *ngIf="itensRelatorio?.analises">
      <div class="ibox-title">
        <h5>Análise</h5>
      </div>
      <div class="ibox-content">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Status</th>
              <th>Situação</th>
              <th>Atualização</th>
            </tr>
          </thead>
          <tbody *ngIf="entrega?.analysis?.length == 0">
            <tr>
              <td colspan="3">
                Nenhum registro encontrado
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="entrega?.analysis?.length > 0">
            <ng-container *ngFor="let item of entrega?.analysis">
              <tr>
                <td>
                  {{ item.status_name }}
                  <br>
                  <span [innerHTML]="item.status1"></span>
                </td>
                <td class="break-word">
                  {{ item.description }}<br>
                  <br>
                  <!-- EXTRA VALUE -->
                  <table class="table table-bordered" *ngIf="item.extrasValues && item.extrasValues.length > 0">
                    <thead>
                      <tr>
                        <th>Título</th>
                        <th>Unid. Med.</th>
                        <th>Meta</th>
                        <th>Realizado</th>
                      </tr>
                    </thead>
                    <tr *ngFor="let value of item.extrasValues">
                      <td>{{ value.title }}</td>
                      <td>{{ value.unit_id }}</td>
                      <td>{{ value.goal }}</td>
                      <td>{{ value.value_done }}</td>
                    </tr>
                  </table>
                </td>
                <td>
                  {{ item.ctr_usu_atu_name }}
                  <br>
                  {{ item.ctr_dth_atu }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div class="ibox" *ngIf="itensRelatorio?.pontos">
      <div class="ibox-title">
        <h5>Pontos Críticos</h5>
      </div>
      <div class="ibox-content">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Ponto Crítico/Risco</th>
              <th>Tipo</th>
              <th>Status</th>
              <th>Probabilidade</th>
              <th>Impacto</th>
              <th>Sinaleira</th>
              <th>Atualização</th>
            </tr>
          </thead>
          <tbody *ngIf="entrega?.critical?.length == 0">
            <tr>
              <td colspan="7">
                Nenhum registro encontrado
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="entrega?.critical?.length > 0">
            <ng-container *ngFor="let item of entrega?.critical">
              <tr>
                <td>{{ item.description }}</td>
                <td>{{ item.nome_tipo }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.critical_probability_name }}</td>
                <td>{{ item.critical_impact_name }}</td>
                <td>
                  <span [innerHTML]="item.status_icon"></span>
                  <br>
                  {{ item.status_label }}
                </td>
                <td>
                  {{ item.user }}
                  <br>
                  {{ item.ctr_dth_atu }}
                </td>
              </tr>
              <tr *ngIf="item.actions && item.actions.length > 0">
                <td colspan="7">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Ação corretiva</th>
                        <th>Status</th>                					
                        <th>Término planejado</th>
                        <th>Término previsto</th>
                        <th></th>    					
                        <th>Atualização</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let value of item.actions">
                        <tr>
                          <td>
                            {{ value.title }}<br>
                            <span *ngIf="value.resp_nome != '' && value.resp_nome != null">
                              Resp.: {{ value.resp_nome }} <br>
                              <span class="manager-info" style="display:none;">
                                E-mail.: {{ value.resp_email }} <br>
                                Telefone.: ({{ value.resp_ddd }}) {{ value.resp_tel }}
                              </span>
                            </span>
                            <span *ngIf="value.resp_nome == '' || value.resp_nome == null">
                              {{ value.responsible }}
                            </span>
                            <br>
                            <span *ngIf="value.lockdown_id" class="vilmar-resp-info">
                              Solicitado nova informação em {{ value.lockdown_dt }}
                              <br>
                              Solicitante: {{ value.lockdown_resp }}
                            </span>
                          </td>
                          <td>{{ value.status }}</td>
                          <td>{{ value.deadline_original }}</td>
                          <td>{{ value.deadline }}</td>
                          <td>
                            {{ value.status1 }}
                            <br>
                            <strong class="text-error">{{ value.diff_days }}</strong>
                          </td>
                          <td>
                            {{ item.user }}
                            <br>
                            {{ item.ctr_dth_atu }}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <strong>Situação: </strong>
                            <br>
                            {{ value.description }}
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div class="ibox" *ngIf="itensRelatorio?.planos">
      <div class="ibox-title">
        <h5>Plano de Ação (iniciativas associadas ao entregável)</h5>
      </div>
      <div class="ibox-content">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Ação</th>
              <th>Status</th>
              <th>Término planejado</th>
              <th>Término previsto</th>
              <th></th>
              <th>Atualização</th>
            </tr>
          </thead>
          <tbody *ngIf="entrega?.actions?.length == 0">
            <tr>
              <td colspan="6">
                Nenhum registro encontrado
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="entrega?.actions?.length > 0">
            <ng-container *ngFor="let item of entrega?.actions">
              <tr>
                <td>
                  {{ item.title }} <br>
                  <span *ngIf="item.resp_nome">
                    Resp.: {{ item.resp_nome }} <br>
                    <span class="manager-info" style="display:none;">
                      E-mail.: {{ item.resp_email }} <br>
                      Telefone.: ({{ item.resp_ddd }}) {{ item.resp_tel }}
                    </span>
                  </span>
                  <span *ngIf="!item.resp_nome">
                    Resp.: {{ item.responsible }}
                  </span>
                  <span *ngIf="item.lockdown_id">
                    Solicitada nova informação em {{ item.lockdown_dt }} <br>
                    <span class="manager-info" style="display:none;">
                      Solicitante: {{ item.lockdown_resp }}
                    </span>
                  </span>
                </td>
                <td>{{ item.status }}</td>
                <td>{{ item.deadline_original }}</td>
                <td>{{ item.deadline }}</td>
                <td>
                  {{ item.status1 }} <br>
                  <strong class="text-error">
                    {{ item.diff_days }}
                  </strong>
                </td>
                <td>
                  {{ item.user }}
                  <br>
                  {{ item.ctr_dth_atu }}
                </td>
              </tr>
              <!-- EXTRA VALUE -->
              <tr *ngIf="item.extrasValues && item.extrasValues.length > 0">
                <td colspan="6" class="break-word">
                  <strong>Situação: </strong><br>
                  {{ item.description }}<br>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Título</th>
                        <th>Unid. Med.</th>
                        <th>Meta</th>
                        <th>Realizado</th>
                        <th>% Real</th>
                      </tr>
                    </thead>
                    <tr *ngFor="let value of item.extrasValues">
                      <td>{{ value.title }}</td>
                      <td>{{ value.unit_id }}</td>
                      <td>{{ value.goal }}</td>
                      <td>{{ value.value_done }}</td>
                      <td>{{ value.value_done_perc }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div class="ibox" *ngIf="itensRelatorio?.cronograma">
      <div class="ibox-title">
        <h5>Cronograma</h5>
      </div>
      <div class="ibox-content">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Status</th>
              <th>% de Execução</th>
              <th>Data de Conclusão Cronograma</th>
              <th>Dias de Atraso</th>
              <th>Linha Base: % Previsto de Execução</th>
              <th>Data de conclusão Linha de Base</th>
              <th>Atualização</th>
            </tr>
          </thead>
          <tbody *ngIf="entrega?.cronogramList?.length == 0">
            <tr>
              <td colspan="7">
                Nenhum registro encontrado
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="entrega?.cronogramList?.length != 0">
            <tr>
              <td>
                <div class="text-center">
                  {{ entrega?.cronogramList.status_label }} <br>
                  <span [innerHTML]="entrega?.cronogramList.status_icon"></span>
                </div>
              </td>
              <td>
                <div class="text-center" style="font-size: 16px;">
                  <strong *ngIf="!(entrega?.cronogramList.progress === false)">{{ entrega?.cronogramList.progress }}%</strong>
                </div>
              </td>
              <td>
                <div class="text-center" style="font-size: 16px;">
                  <strong>{{ entrega?.cronogramList.dt_foreseen_conclusion }}</strong>
                </div>
              </td>
              <td>
                <div class="text-center" style="font-size: 16px; color: red;">
                  <strong>{{ entrega?.cronogramList.diff_days }}</strong>
                </div>
              </td>
              <td>
                <div class="text-center" style="font-size: 16px;">
                  <strong>{{ entrega?.cronogramList.bl_progress_would }}</strong>
                </div>
              </td>
              <td>
                <div class="text-center" style="font-size: 16px;">
                  <strong>{{ entrega?.cronogramList.bl_dt_foreseen_conclusion }}</strong>
                </div>
              </td>
              <td>
                <div class="text-center">
                  {{ entrega?.cronogramList.cron_ctr_dth_atu }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>